module.exports = __webpack_public_path__ + "static/img/doc-file-format.f55b888.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/document/doc-file-format.png
// module id = 7nyX
// module chunks = 4